import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks'; 
import FormStructure from '../../client_forms/solepower/form_structure.js';
import { store, updateFormField } from '../../state/formState';
import FormField from '../form/form_field';

const Step2 = ({ update, errors = {} }) => {
  const [startH, setStartH] = useState('');
  const [startM, setStartM] = useState('');
  const [startP, setStartP] = useState('AM');

  const [endH, setEndH] = useState('');
  const [endM, setEndM] = useState('');
  const [endP, setEndP] = useState('AM');

  const otherFieldKeys = ['PlannedGuestCount', 'Operation'];
  const fields = FormStructure.layout.rows
    .flatMap(row => row.fields)
    .filter(field => otherFieldKeys.includes(field.mapping));

  const getField = (key) => fields.find(f => f.mapping === key);

  useEffect(() => {
    const formatM = (m) => (m ? m.toString().padStart(2, '0') : '00');

    if (startH && startM) {
      store.formData.StartTime = `${startH}:${formatM(startM)} ${startP}`;
    } else {
      store.formData.StartTime = '';
    }
    
    if (endH && endM) {
      store.formData.EndTime = `${endH}:${formatM(endM)} ${endP}`;
    } else {
      store.formData.EndTime = '';
    }
    update();
  }, [startH, startM, startP, endH, endM, endP]);

  return (
    <div className="step-inner step-2-design">
      <h2>Provide a few details about your timing and setup.</h2>
      
      {getField('PlannedGuestCount') && (
        <FormField 
          config={getField('PlannedGuestCount')} 
          value={store.formData.PlannedGuestCount || ''}
          error={errors.PlannedGuestCount}
          onInput={(val) => { store.formData.PlannedGuestCount = val; update(); }}
        />
      )}

      <div className="time-field-group">
        <label>What time does the event get started?:*</label>
        <div className="time-input-container">
          <input type="number" placeholder="HH" min="1" max="12" value={startH} onInput={(e) => setStartH(e.target.value)} />
          <span className="time-separator text-white">:</span>
          <input type="number" placeholder="MM" min="0" max="59" value={startM} onInput={(e) => setStartM(e.target.value)} />
          <select value={startP} onChange={(e) => setStartP(e.target.value)}>
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </select>
        </div>
        {errors.StartTime && <span className="error-message">{errors.StartTime}</span>}
      </div>

      <div className="time-field-group">
        <label>What time does the event wrap up?</label>
        <div className="time-input-container">
          <input type="number" placeholder="HH" min="1" max="12" value={endH} onInput={(e) => setEndH(e.target.value)} />
          <span className="time-separator text-white">:</span>
          <input type="number" placeholder="MM" min="0" max="59" value={endM} onInput={(e) => setEndM(e.target.value)} />
          <select value={endP} onChange={(e) => setEndP(e.target.value)}>
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </select>
        </div>
        {errors.EndTime && <span className="error-message">{errors.EndTime}</span>}
      </div>

      {getField('Operation') && (
        <FormField 
          config={getField('Operation')} 
          value={store.formData.Operation || []}
          error={errors.Operation}
          onInput={(val) => { store.formData.Operation = val; update(); }}
        />
      )}

      {/* 1. Radio Buttons */}
      <div className="form-group custom-radio-section" style={{ marginTop: '25px' }}>
        <label className="field-label">Are you working with an event planner?</label>
        <div className="radio-group" style={{ display: 'flex', gap: '20px', margin: '10px 0' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
            <input 
              type="radio" 
              name="WorkingWithPlanner" 
              value="Yes" 
              checked={store.formData.WorkingWithPlanner === 'Yes'} 
              onChange={() => { 
                updateFormField('WorkingWithPlanner', 'Yes'); 
                update(); 
              }} 
            /> Yes
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}>
            <input 
              type="radio" 
              name="WorkingWithPlanner" 
              value="No" 
              checked={store.formData.WorkingWithPlanner === 'No'} 
              onChange={() => { 
                updateFormField('WorkingWithPlanner', 'No');
                // Auto-clear the text payload if they flip back to "No"
                updateFormField('EventExtra2', '');
                update(); 
              }} 
            /> No
          </label>
        </div>
      </div>

      {/* 2. Conditional Planner Input Field */}
      {store.formData.WorkingWithPlanner === 'Yes' && (
        <div className="form-group animate-fade-in">
          <FormField 
            config={{
              type: 'text',
              label: 'Who is your planner?',
              mapping: 'EventExtra2', 
              placeholder: 'Enter name or company...'
            }}
            value={store.formData.EventExtra2 || ''}
            error={errors.EventExtra2}
            onInput={(val) => {
              updateFormField('EventExtra2', val);
              update();
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Step2;